import { specialFont } from "../../Infrastructure/Theme/fontFamily"

const blogSx = {
  errorContainer: {
    mt: 4,
  },
  notFoundContainer: {
    mt: 0,
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    bgcolor: "background.paper",
  },
  notFoundBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 2,
  },
  notFoundTitle: {
    fontSize: "28px",
    fontWeight: 700,
    color: "primary.main",
    mb: 1,
    textAlign: "center",
    letterSpacing: "0.5px",
    fontFamily: specialFont,
  },
  notFoundSubtitle: {
    fontSize: "18px",
    color: "text.secondary",
    textAlign: "center",
    mb: 2,
  },
  mainContainer: {
    my: 2,
    minHeight: "100vh",
    position: "relative",
    px: { xs: 2, md: 4 },
  },
  backButtonBox: {
    mb: 4,
    position: "relative",
    top: 16,
    left: -10,
  },
  title: {
    mb: 4,
    fontWeight: 700,
    color: "primary.main",
    letterSpacing: "0.5px",
    fontFamily: specialFont,
    wordBreak: "break-word",
    fontSize: { xs: "20px", sm: "24px", md: "28px" },
  },
  contentBox: {
    p: { xs: 0, md: 0 },
    bgcolor: "background.paper",
    wordBreak: "break-word",
    lineHeight: 1.8,
    fontSize: { xs: "15px", md: "17px" },
    color: "text.secondary",
    "& h1, & h2, & h3": {
      fontWeight: 600,
      color: "text.primary",
      mt: 3,
      mb: 2,
    },
    "& p": {
      mb: 2,
    },
    "& img": {
      maxWidth: "100%",
      borderRadius: "12px",
      my: 3,
      boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
    },
    "& ul, & ol": {
      pl: 3,
      mb: 2,
    },
    "& blockquote": {
      pl: 3,
      borderLeft: "4px solid",
      borderColor: "primary.main",
      color: "text.primary",
      fontStyle: "italic",
      my: 3,
    },
  },
}

const blogListSx = {
  loadingBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  },
  errorContainer: {
    mt: 4,
  },
  mainContainer: {
    mt: 4,
    minHeight: "100vh",
  },
  title: {
    fontSize: { xs: "30px", sm: "40px" },
    textAlign: "center",
    fontWeight: "bold",
  },
  gridBox: {
    display: "grid",
    gap: 2,
  },
  card: {
    borderRadius: "16px",
    boxShadow: 3,
    mb: 2,
    textDecoration: "none",
    transition: "0.3s",
    "&:hover": {
      boxShadow: 6,
      transform: "translateY(-3px)",
    },
    "&:hover .blog-title": {
      color: "primary.main",
    },
  },
  blogTitle: {
    fontSize: "20px",
    fontWeight: "bold",
    textDecoration: "none",
    color: "black",
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    transition: "color 0.3s",
    mb: 1,
    textTransform: "capitalize"
  },
  contentBox: {
    fontSize: "16px",
    color: "#555",
    lineHeight: 1.6,
    overflow: "hidden",
    maxHeight: "4.8em",
    wordBreak: "break-word",
    "& p": {
      margin: 0,
    },
  }
}

export { blogSx, blogListSx }